import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {httpGetUnresponsiveHostReasons} from '@features/assignment/http/assignment.http'
import {z} from 'zod'
import {captureException} from '@sentry/react'
import {parseAxiosPromise} from '@/axiosInstance.ts'

export const ResponseUnresponsiveHostReasons = z.array(
    z.object({
        name: z.enum([
            'host_has_not_responded',
            'host_has_stopped_responding',
            'invalid_cellular_number_provided',
            'other'
        ]),
        id: z.number().int().positive()
    })
)
export type ResponseUnresponsiveHostReasons = z.infer<typeof ResponseUnresponsiveHostReasons>

export const useUnresponsiveHostReasons = () => {
    return useQuery({
        queryKey: [QUERY_KEYS.UNRESPONSIVE_HOST_REASONS],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGetUnresponsiveHostReasons(),
                responseShape: ResponseUnresponsiveHostReasons,
                onZodError: captureException
            })
    })
}
